import { ContactBar, ContactAvatar, TContactType } from '@cian/contact-card-component';
import React from 'react';

import { AgentBookButtonContainer } from './AgentBookButtonContainer';
import * as styles from './AgentContainer.css';
import { AgentPhoneButtonContainer } from './AgentPhoneButtonContainer';
import { AgentShowMoreOffersContainer } from './AgentShowMoreOffersContainer';
//TODO: Это надо вернуть попапом в следующей итерации
// import { AgentProofsContainer } from './AgentProofsContainer';
import { AgentWorkHonestlyProofsContainer } from './AgentWorkHonestlyProofsContainer';
import { getAgentLevelInfo } from './AgentWorkHonestlyProofsContainer/utils';
import { ChatButtonContainer } from './ChatButtonContainer';
import { JoinElectronicTradingButtonContainer } from './JoinElectronicTradingButtonContainer';
import { NewbuildingBrokerButtonContainer } from './NewbuildingBrokerButtonContainer';
import { SuperAgentLevelViewContainer } from './SuperAgentLevelViewContainer';
import { AgentLevelView } from '../../../components/AgentLevelView';
import { BrandingLevelWrapper } from '../../../components/BrandingLevelWrapper';
import { ContactActionsLayout } from '../../../components/ContactActionsLayout';
import { useOfferContext } from '../../../context';
import { getAgentTypeTitle } from '../../../utils/getAgentTypeTitle';

const AVATAR_TYPE: {
  [key: string]: string | undefined;
} = {
  builderRepresentative: 'builder',
  consultant: 'builder',
  managementCompany: 'agency',
  realtor: 'agent',
  // У электронных торгов все отображения аватара как у типа "bank"
  tradingPlatform: 'bank',
  government: 'bank',
};

export function AgentContainer() {
  const offerData = useOfferContext();
  const {
    agentType,
    agentImageLink,
    agentName,
    agentProfileLink,
    offer: { brandingLevel, dailyrent },
  } = offerData;
  const agentLevelInfo = getAgentLevelInfo(offerData);
  const avatarType = (AVATAR_TYPE[agentType] || agentType) as TContactType;

  if (dailyrent?.hotelData?.isHotel) {
    return (
      <div className={styles['hotel-button']}>
        <AgentBookButtonContainer />
      </div>
    );
  }

  return (
    <BrandingLevelWrapper brandingLevel={brandingLevel}>
      <ContactBar
        title={getAgentTypeTitle(agentType)}
        avatar={<ContactAvatar type={avatarType} src={agentImageLink} />}
        name={agentName || ''}
        href={agentProfileLink}
        target="_blank"
        nameIcons={agentLevelInfo && <AgentLevelView agentLevelInfo={agentLevelInfo} />}
        qualityInfo={<SuperAgentLevelViewContainer />}
        labels={<AgentWorkHonestlyProofsContainer />}
        actions={
          <ContactActionsLayout
            showMoreOffersLink={<AgentShowMoreOffersContainer />}
            chatButton={<ChatButtonContainer />}
            brokerButton={<NewbuildingBrokerButtonContainer />}
            phoneButton={<AgentPhoneButtonContainer />}
            electronicTradingButton={<JoinElectronicTradingButtonContainer />}
            bookButton={<AgentBookButtonContainer />}
          />
        }
      />
    </BrandingLevelWrapper>
  );
}
